import { render, staticRenderFns } from "./robotArmControl.vue?vue&type=template&id=15de3f64&scoped=true&"
import script from "./robotArmControl.vue?vue&type=script&lang=js&"
export * from "./robotArmControl.vue?vue&type=script&lang=js&"
import style0 from "./robotArmControl.vue?vue&type=style&index=0&id=15de3f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de3f64",
  null
  
)

export default component.exports